import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';

const navStyle = ({ isActive }: { isActive: boolean }) => ({
  display: 'block',
  padding: '10px 16px',
  borderRadius: 6,
  marginBottom: 4,
  color: isActive ? '#fff' : '#374151',
  background: isActive ? '#1a1a1a' : 'transparent',
  fontSize: 14,
  fontWeight: 500 as const,
});

export function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [openCases, setOpenCases] = useState(0);

  // Refresh on navigation so the badge drops after replying to a case.
  useEffect(() => {
    api
      .get<{ open: number }>('/api/admin/support/stats')
      .then((d) => setOpenCases(d.open))
      .catch(() => {});
  }, [location.pathname]);

  const logout = async () => {
    try {
      await api.post('/api/admin/auth/logout');
    } catch {}
    navigate('/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <aside
        style={{
          width: 240,
          background: '#fff',
          borderRight: '1px solid #e5e5e5',
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <h1
          style={{
            margin: '0 0 32px',
            fontFamily: 'Georgia, serif',
            fontSize: 18,
            letterSpacing: 2,
            textTransform: 'uppercase',
            fontWeight: 400,
          }}
        >
          This place is your space · Admin
        </h1>
        <nav style={{ flex: 1 }}>
          <NavLink to="/" end style={navStyle}>
            Dashboard
          </NavLink>
          <NavLink to="/orders" style={navStyle}>
            Orders
          </NavLink>
          <NavLink to="/customers" style={navStyle}>
            Customers
          </NavLink>
          <NavLink to="/photos" style={navStyle}>
            Photos
          </NavLink>
          <NavLink to="/about" style={navStyle}>
            About page
          </NavLink>
          <NavLink to="/print-sizes" style={navStyle}>
            Print sizes
          </NavLink>
          <NavLink to="/coupons" style={navStyle}>
            Coupons
          </NavLink>
          <NavLink to="/support" style={navStyle}>
            {({ isActive }) => (
              <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Support
                {openCases > 0 && (
                  <span
                    style={{
                      background: isActive ? '#fff' : '#b45309',
                      color: isActive ? '#1a1a1a' : '#fff',
                      borderRadius: 10,
                      padding: '1px 8px',
                      fontSize: 12,
                      fontWeight: 600,
                    }}
                  >
                    {openCases}
                  </span>
                )}
              </span>
            )}
          </NavLink>
          <NavLink to="/emails" style={navStyle}>
            Emails
          </NavLink>
          <NavLink to="/settings" style={navStyle}>
            Settings
          </NavLink>
        </nav>
        <button
          onClick={logout}
          style={{
            padding: '10px 16px',
            border: '1px solid #e5e5e5',
            background: '#fff',
            cursor: 'pointer',
            borderRadius: 6,
            color: '#6b7280',
            fontSize: 14,
          }}
        >
          Sign Out
        </button>
      </aside>
      <main style={{ flex: 1, padding: 40, maxWidth: 1200 }}>
        <Outlet />
      </main>
    </div>
  );
}
